import { useCallback } from 'react';
import { PolicyLevel, Relationship } from '@/lib/enums';

const groupingRelationships = new Set([
  Relationship.MANAGER,
  Relationship.SUPPORTER,
]);

export default function useGroupRoles(me, level, isHistorical, relationships) {
  return useCallback(
    (roles) => {
      if (isHistorical) {
        return false;
      }

      // assume admins can create any groups
      if (level === PolicyLevel.ADMIN) {
        return true;
      }

      const canGroup = Object.values(relationships?.current ?? {}).some((r) =>
        groupingRelationships.has(r)
      );

      if (!canGroup) {
        return false;
      }

      for (const role of roles) {
        const relationship = relationships?.current[role.uuid];
        if (!groupingRelationships.has(relationship)) {
          return false;
        }
      }

      return true;
    },
    [me, level, isHistorical, relationships]
  );
}
